import { render } from "./CategoryIndex.vue?vue&type=template&id=4b79a121&scoped=true"
import script from "./CategoryIndex.vue?vue&type=script&lang=js"
export * from "./CategoryIndex.vue?vue&type=script&lang=js"

import "./CategoryIndex.vue?vue&type=style&index=0&id=4b79a121&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b79a121"]])

export default __exports__